module.exports = __webpack_public_path__ + "static/img/NatourMontenegroLG.73f740a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/NatourMontenegroLG.png
// module id = U1Mg
// module chunks = 0